<script>
export default {
  name: 'UpdateBanner',
  render() {
    return null;
  },
};
</script>
